/* tslint:disable */
/* eslint-disable */
/**
 * ANEP Device Provisioning API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCreate
 */
export interface ClientCreate {
    /**
     * 
     * @type {string}
     * @memberof ClientCreate
     */
    name: string;
}

/**
 * Check if a given object implements the ClientCreate interface.
 */
export function instanceOfClientCreate(value: object): value is ClientCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ClientCreateFromJSON(json: any): ClientCreate {
    return ClientCreateFromJSONTyped(json, false);
}

export function ClientCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function ClientCreateToJSON(json: any): ClientCreate {
    return ClientCreateToJSONTyped(json, false);
}

export function ClientCreateToJSONTyped(value?: ClientCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

